export default function TypirLogo({ size = 40 }) {
  return (
    <div className="flex items-center gap-2">
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="100" height="100" fill="#000000" rx="20"/>
        <text 
          x="50" 
          y="72" 
          fontFamily="Arial, sans-serif" 
          fontSize="60" 
          fontWeight="bold" 
          fill="#22c55e" 
          textAnchor="middle"
        >
          T
        </text>
        <rect x="35" y="75" width="30" height="4" fill="#22c55e" rx="2"/>
      </svg>
      <span className="text-2xl font-bold text-white">Typir</span>
    </div>
  )
}

